import React from 'react';

type Props = React.PropsWithChildren<{}>;

export const Copy = (props: Props) => {
  return (
    <div className="font-medium text-sm md:text-base">{props.children}</div>
  );
};
